import { Form } from "formik";
import React from "react";
import { InputFormik, PhoneInputFormik, SelectFormik } from "..";
import { Box, Flex } from "shipnow-mercurio";
import PropTypes from "prop-types";
import { DOC_TYPES_LIST } from "../../constants/settings.consts";

const DEFAULT_PROPS = {
  onChange: null,
};

export const BuyerFormFormik = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  return (
    <Form>
      <Flex justifyContent="flex-start" alignItems="flex-start">
        <InputFormik
          label="Nombre"
          name="name"
          onChange={attrs.onChange}
          margin="b-20 r-20"
        />

        <InputFormik
          label="Apellido"
          name="last_name"
          onChange={attrs.onChange}
          margin="b-20"
        />
      </Flex>
      <InputFormik label="Email" name="email" onChange={attrs.onChange} />
      <Box margin="b-20">
        <PhoneInputFormik
          label="Teléfono"
          isOptional
          name="phone"
          onChange={attrs.onChange}
          helpText="Lo utilizaremos para contactarnos si surge un inconveniente."
        />
      </Box>
      <Flex justifyContent="flex-start" alignItems="flex-start">
        <Box width="35%">
          <SelectFormik
            options={DOC_TYPES_LIST}
            label="Documento"
            isOptional
            name="doc_type"
            onChange={attrs.onChange}
            minWidth="20px"
            margin="b-20 r-20"
          />
        </Box>
        <Box width="65%">
          <InputFormik
            name="doc_number"
            label="Número"
            type="number"
            onChange={attrs.onChange}
            isOptional
            margin="b-20 r-20"
          />
        </Box>
      </Flex>
    </Form>
  );
};

BuyerFormFormik.propTypes = {
  onChange: PropTypes.func,
};
